import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';
import { Grid, Card } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Input, Spin,} from 'antd';
import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';

import Services, {
  IGetAllFundosTable,
  IRequestFundo,
} from './services';

const columnsLabel = {
  id: 'ID',
  nome: 'Descrição',
};

const Fundo: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IGetAllFundosTable[]>([]);
  const [formref] = Form.useForm();
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(false);

  async function loadGetAllFundos() {
    setLoading(true);
    await api
      .get('/api/fundos/GetAll')
      .then(response => {
        const items = response.data;
        const itemData: IGetAllFundosTable[] = items.map((item: any) => ({
          id: item.id,
          nome:item.nome,
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar(`Ocorreu um erro`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  }

   async function onSubmit(values: any) {
    setLoadingCreate(true);

    const createFundo: IRequestFundo = {
      nome: values.fundo,
    };

    const service = new Services();
    const { error, response } = await service.CreateFundo(createFundo);

    setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      clearDados();
      setHabilitarBotao(false);

      loadGetAllFundos();

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  const clearDados = () => {
    formref.setFieldsValue({
      fundo: '',
    });
  };


  useEffect(() => {
    loadGetAllFundos();
    window.document.title = 'CRM - Formas contribuições';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        {/* FORMULARIO  */}
        <Grid item lg={12} sm={12} xs={12}>
          <Spin
            size="large"
            spinning={loadingCreate}
            tip="Enviando dados..."
          >
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError={true}
              onFinish={onSubmit}
              labelAlign="left"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              requiredMark={false}
              initialValues={{

                dia_semana: '',
                horario: '',
              }}
            >

              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* Lista dos fundos cadastrados  */}
                <Grid container item lg={6} sm={6} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 550,  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>


                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
                    >

                      <TableCustomKeysNoPagination
                        loading={loading}
                        columns={[columnsLabel]}
                        FieldsBold={['nome']}
                        data={data}
                        keys={[
                          'id',
                          'nome',
                        ]}
                      />
                    </Grid>
                  </Card>
                </Grid>

                {/* Novo cadastro de fundo  */}
                <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item lg={10} md={10} xs={10} style={{ paddingLeft: 250, paddingRight: 5, alignSelf: 'end' }}>
                      <ButtonComponent
                        fullWidth
                        style={{ height: 46, borderRadius: 5}}
                        color={"secondary"}
                        onClick={() => {
                          setHabilitarBotao(true)
                        }}
                      >
                        Adicionar novo fundo
                      </ButtonComponent>
                    </Grid>

                    <Grid container>

                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="fundo" label="Fundo"
                          rules={[
                            {
                              required: true,
                              message: 'Adicione um fundo',
                            },
                          ]}
                        >
                          <Input  disabled={habilitarBotao !== true}/>
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          disabled={habilitarBotao !== true}
                          onClick={clearDados}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                          disabled={habilitarBotao !== true}
                        >
                          Salvar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Fundo;
